import {Box, styled} from "@mui/material";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

export const ToastyContainer = styled(Box)(({theme}) => ({
    "& .Toastify__toast": {
        fontFamily: "inherit!important",
        fontSize: ".8rem",
        fontWeight: 500,
        [theme.breakpoints.down("lg")]: {
            margin: "1rem 2rem",
        }
    },
}));
ToastyContainer.defaultProps = {
    component: ToastContainer,
}